export enum COLOR {
  Black = 'black',
  Dark1 = 'dark1',
  Dark2 = 'dark2',
  Dark3 = 'dark3',
  Gold1 = 'gold1',
  Gold2 = 'gold2',
  Gray1 = 'gray1',
  Gray2 = 'gray2',
  Gray3 = 'gray3',
  Highlight = 'highlight',
  White = 'white',
}
